import { IdCardRequest } from '../types';

export const INITIAL_ID_CARD_ADD_FORM_VALUES = {
  name: '',
  frontImage: {
    fakepath: '',
    src: '',
  },
  backImage: {
    fakepath: '',
    src: '',
  },
};

export const EMPTY_ID_CARD: IdCardRequest = {
  createdBy: null,
  updatedBy: null,
  displayOrder: 999,
  frontImage: '',
  iconCode: '',
  name: '',
};

export const POST_ID_CARD_QUERY_KEY = ['post', 'ecards'] as const;
